import { render, staticRenderFns } from "./BetRejectedAlert.vue?vue&type=template&id=6b912f0a"
import script from "./BetRejectedAlert.vue?vue&type=script&lang=js"
export * from "./BetRejectedAlert.vue?vue&type=script&lang=js"
import style0 from "./BetRejectedAlert.vue?vue&type=style&index=0&id=6b912f0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports